function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(13 2.8)"
}, React.createElement("path", {
  d: "M16.2 11a1 1 0 0 1-1.3 0 1 1 0 0 1 0-1.4l4-3.3a1 1 0 0 1 1.3 0c.3.5.3 1 0 1.4l-4 3.3zm-.1 6.4c0-.7.4-1.3 1-1.8l1.7-1.5c2.2-1.9 5.9-8 8-11.8.7-1-.4-2.4-1.5-2a60.2 60.2 0 0 0-13 6.1L10.4 8a2.9 2.9 0 0 1-1.9.7C2.6 8.6 1 11 1 11l.8.8s3.5-.5 5.4 1.8L5.5 15l1 1.1-1.2 1 2.1 2.6.3-.3-1-2.7 2.5 2.8.5-.5-.7-3 2 2.1c2 2.3.9 5.6.9 5.6l.7 1s2.5-1.5 3.5-7.3z",
  fill: "#FFF"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 -.2)"
}, React.createElement("path", {
  d: "M18.8 34.4c-5.8.3-11-2.4-14.1-6.8-.2-.2 0-.5.3-.3 4 2.7 10.2 2 14.3-5.5-20.5 5.7-18-20.2-1.4-20 5.8.1 10.8 3 13.7 7.6a1 1 0 0 1 1.3-.1 1 1 0 0 1 0 1.5l-.3.3a16.2 16.2 0 0 1 1.6 7.4C34 27 27.2 34 18.8 34.4M17.8.2A17.9 17.9 0 1 0 18 36 17.9 17.9 0 0 0 18 .2",
  fill: "#FFF"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 35.8,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/rocket-logo.7561b5d1.svg";
export { SvgComponent as ReactComponent };